import React, { useEffect } from 'react';

import { useLoaderData } from 'react-router-dom';

import LinearProgress from '@mui/material/LinearProgress';

import * as shuttle from 'shuttle';

export async function loader(_store, data) {
  const url = new URL(data?.request?.url);
  const { searchParams: params } = url;
  const result = {
    intent: params.get('payment_intent'),
    secret: params.get('payment_intent_client_secret'),
  };

  return result;
}

export default function AcknowledgeStripePayment() {
  const data = useLoaderData();

  async function sendStripeAck() {
    try {
      await shuttle.publish('stripe', 'acknowledge', data);
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    sendStripeAck();
  }, []);

  return <LinearProgress />;
}
